export default __webpack_public_path__ + "static/media/120t.cdd8baaf.jpg";